export const DOWNLOAD_RESET = 'DOWNLOAD_RESET';
export const DOWNLOAD_REQUEST = 'DOWNLOAD_REQUEST';
export const DOWNLOAD_REQUEST_FAILED = 'DOWNLOAD_REQUEST_FAILED';
export const DOWNLOAD_REQUEST_SUCCESS = 'DOWNLOAD_REQUEST_SUCCESS';
export const FETCH_RENDER_STATUS_FAILED = 'FETCH_RENDER_STATUS_FAILED';
export const STOP_RENDER_STATUS_POLLING = 'STOP_RENDER_STATUS_POLLING';
export const START_RENDER_STATUS_POLLING = 'START_RENDER_STATUS_POLLING';
export const POLLING_CANCELLED = 'POLLING_CANCELLED';
export const RENDER_FAILED = 'RENDER_FAILED';
export const GET_VIDEO_DOWNLOAD_URL_SUCCESS = 'GET_VIDEO_DOWNLOAD_URL_SUCCESS';
export const GET_VIDEO_DOWNLOAD_URL_FAILED = 'GET_VIDEO_DOWNLOAD_URL_FAILED';
export const UPDATE_DOWNLOAD_COUNT = 'UPDATE_DOWNLOAD_COUNT';
export const UPDATE_DOWNLOAD_COUNT_FAILED = 'UPDATE_DOWNLOAD_COUNT_FAILED';
export const FETCH_RENDER_PROGRESS_SUCCESS = 'FETCH_RENDER_PROGRESS_SUCCESS';

export const requestDownload = (scribeId, format) => ({
  type: DOWNLOAD_REQUEST,
  scribeId,
  format
});

export const downloadRequestSuccess = numSegments => {
  return {
    type: DOWNLOAD_REQUEST_SUCCESS,
    numSegments
  };
};

export const downloadRequestFailed = error => {
  return {
    type: DOWNLOAD_REQUEST_FAILED,
    error
  };
};

export const downloadReset = () => ({ type: DOWNLOAD_RESET });

export const fetchRenderStatusFailed = (error, shortId) => ({
  type: FETCH_RENDER_STATUS_FAILED,
  error,
  shortId
});

export const stopRenderStatusPolling = (shortId, format) => ({
  type: STOP_RENDER_STATUS_POLLING,
  shortId,
  format
});

export const startRenderStatusPolling = (shortId, format) => ({
  type: START_RENDER_STATUS_POLLING,
  shortId,
  format
});

export const pollingCancelled = shortId => ({
  type: POLLING_CANCELLED,
  shortId
});

export const renderFailed = error => ({
  type: RENDER_FAILED,
  error
});

export const getVideoDownloadUrlSuccess = url => ({
  type: GET_VIDEO_DOWNLOAD_URL_SUCCESS,
  downloadUrl: url
});

export const getVideoDownloadUrlFailed = error => ({
  type: GET_VIDEO_DOWNLOAD_URL_FAILED,
  error
});

export const updateDownloadCount = count => ({
  type: UPDATE_DOWNLOAD_COUNT,
  count
});

export const updateDownloadCountFailed = () => ({
  type: UPDATE_DOWNLOAD_COUNT_FAILED
});

export const fetchRenderProgressSuccess = (shortId, result) => ({
  type: FETCH_RENDER_PROGRESS_SUCCESS,
  shortId,
  result
});
